import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, translate, formatDateToPtbr, getUserNameToName } from '../../../../utils/util';
import * as containerAction from '../../../../actions/containerAction';
import ContainerService from '../../../../services/ContainerService';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { Breadcrumbs, Input, Button, Collapsible, Table } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';

const HarborList = (props) => {
    const messageModal = useRef();
    const [harbors, setHarbors] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [selected, setSelected] = useState(undefined);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        setHarbors(props.harbors?.items || []);
        // eslint-disable-next-line
    }, [props?.harbors?.items]);

    const onSearch = (click) => {
        props.getPagedHarbor({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const openModal = (data) => {
        setSelected(data)
        messageModal.current.show();
    }

    const deleteSelected = () => {
        props.deleteHarbor(selected.id, () => {
            messageModal.current.close();
            setSelected(undefined);
            onSearch(true);
        });
    };

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItemChange = (item) => {
        props.setHarbor(item);
        props.history.push({
            pathname: '../harbor/insert',
            state: { update: true }

        });
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'code',
                header: 'Código',
                align: 'left',
                sortable: true
            },
            {
                field: 'description',
                header: 'Descrição',
                align: 'left',
                sortable: true
            },
            {
                field: 'countryCode',
                header: 'Codigo País',
                align: 'left',
                sortable: true
            },
            {
                field: 'ecomexCode',
                header: 'Codigo Ecomex',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.createdBy),
                align: 'left',
            },
            {
                field: 'updatedOn',
                body: (rowData) => rowData.updatedOn ? formatDateToPtbr(rowData.updatedOn) : '-',
                header: 'Data Atualização',
                align: 'left',
                sortable: true
            },
            {
                field: 'updatedBy',
                header: 'Atualizado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || ""),
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => onSelectItemChange(row)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>edit</i>
            )
        },
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => openModal(row)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'red' }}>delete</i>
            )
        }
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Portos" }} />
            {
                checkPermission(PERMISSIONS.Warehouse_Container.Config.Harbor) &&            
                <i className={`mdi mdi-36px mdi-sticker-plus above-btn`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.history.push({ pathname: './insert' })} />
            }
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="listHarbor" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s3">
                                            <Input
                                                id="code"
                                                name='code'
                                                label="Código"
                                                type="text"
                                                value={filter?.code || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s7">
                                            <Input
                                                id="description"
                                                name='description'
                                                label="Descrição"
                                                type="text"
                                                value={filter?.description || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="ecomexCode"
                                                name='ecomexCode'
                                                label={"Código Ecomex"}
                                                maxlength={3}
                                                type="number"
                                                value={filter?.ecomexCode || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="countryCode"
                                                name='countryCode'
                                                label={"Código País"}
                                                type="text"
                                                value={filter?.countryCode || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <Table
                    totalPages={props.harbors?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={harbors}
                    actions={configActions()} />
            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={() => {
                    if (selected) {
                        deleteSelected()
                    }
                }}
                onCancel={() => setSelected(undefined)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        harbors: state.containerReducer.harborPaged,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPagedHarbor: (vision, filter) => {
            dispatch(ContainerService.getPagedHarbor(vision, filter));
        },
        setHarbor: (data) => {
            dispatch(containerAction.setHarbor(data));
        },
        deleteHarbor: (id, callback) => {
            dispatch(ContainerService.deleteHarbor(id, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HarborList));
